import React from 'react'
import styled from 'styled-components'
import marker_red from 'src/assets/images/marker_red.svg'
import marker_yellow from 'src/assets/images/marker_yellow.svg'
import marker_blue from 'src/assets/images/marker_blue.svg'
import marker_green from 'src/assets/images/marker_green.svg'
import marker_highschool from 'src/assets/images/marker_highschool.svg'
import marker_specialize from 'src/assets/images/marker_specialize.svg'
import marker_purpose from 'src/assets/images/marker_purpose.svg'
import marker_etc from 'src/assets/images/marker_etc.svg'
import marker_self from 'src/assets/images/marker_self.svg'
import marker_two from 'src/assets/images/marker_two.svg'
import marker_four from 'src/assets/images/marker_four.svg'
import marker_military from 'src/assets/images/marker_military.svg'
import marker_associate from 'src/assets/images/marker_associate.svg'
import ex from 'src/assets/images/Ex.svg'

interface Props{
  isInfo : boolean
  setIsInfo: React.Dispatch<React.SetStateAction<boolean>>;
}

const InfoWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background-color: white;
  z-index: 1301;
  padding: 44px 30px;
  display: flex;
  flex-direction: column;
  gap: 34px;
`
const MarkerContainer = styled.div`
  border-radius: 5px;
  border: 2px solid #06799B;
`
const NameBox = styled.div`
  position:relative;
  left: 15px;
  top: -15px;
  background-color: #06799B;
  color: white;
  padding: 5px 10px;
  width: fit-content;
  border-radius: 21px;
  font-size: 14px;
`
const MarkerBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 20px;
  text-align: center;
  white-space: nowrap;
  font-size: 14px;
  min-width: 60px;
  max-width: 60px;
`
const MarkerWrapper = styled.div`
  padding: 0px 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 15px;
  box-sizing: border-box;
`

const Info = ({isInfo, setIsInfo}:Props) => {

  return (
    <>
    {isInfo && <InfoWrapper onClick={()=>setIsInfo((state)=>!state)}>
      <img src={ex} alt="" style={{width:'16px',marginLeft:'auto'}}/>
        <MarkerContainer>
          <NameBox>미방문 기간</NameBox>
          <MarkerWrapper>
            <MarkerBox>
              <img src={marker_red} alt="" />
              2년 초과
            </MarkerBox>
            <MarkerBox>
              <img src={marker_yellow} alt="" />
              2년 이내
            </MarkerBox>
            <MarkerBox>
              <img src={marker_blue} alt="" />
              1년 이내
            </MarkerBox>
            <MarkerBox>
              <img src={marker_green} alt="" />
              6개월 이내
            </MarkerBox>
          </MarkerWrapper>
        </MarkerContainer>
        <MarkerContainer>
          <NameBox>고등학교</NameBox>
          <MarkerWrapper style={{gap:0}}>
            <MarkerBox>
              <img src={marker_highschool} alt="" />
              일반고
            </MarkerBox>
            <MarkerBox>
              <img src={marker_specialize} alt="" />
              특성화고
            </MarkerBox>
            <MarkerBox>
              <img src={marker_purpose} alt="" />
              특목고
            </MarkerBox>
            <MarkerBox>
              <img src={marker_self} alt="" />
              자사고
            </MarkerBox>
            <MarkerBox>
              <img src={marker_etc} alt="" />
              기타
            </MarkerBox>
          </MarkerWrapper>
        </MarkerContainer>
        <MarkerContainer>
          <NameBox>대학교</NameBox>
          <MarkerWrapper style={{gap:'35px'}}>
            <MarkerBox>
              <img src={marker_two} alt="" />
              2년제 대학
            </MarkerBox>
            <MarkerBox>
              <img src={marker_four} alt="" />
              4년제 대학
            </MarkerBox>
          </MarkerWrapper>
        </MarkerContainer>
        <MarkerContainer>
          <NameBox>대학교</NameBox>
          <MarkerWrapper style={{gap:'35px'}}>
            <MarkerBox>
              <img src={marker_military} alt="" />
              학군단 설치여부
            </MarkerBox>
            <MarkerBox>
              <img src={marker_associate} alt="" />
              군 협약여부
            </MarkerBox>
          </MarkerWrapper>
        </MarkerContainer>
        </InfoWrapper>}
    </>
  )
}

export default Info